var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-ontick-blue-900 rounded-sm py-0.5 px-2 text-[10px] font-semibold text-white"},[_vm._v(" "+_vm._s(_vm.symbol)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }